(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nw-script-pdp-2026"] && !Shopify.designMode) return;
  try {
    function injectSizeGuideLink() {
  const easySizeButton = document.querySelector('#easysize_button');
  if (!easySizeButton) return;

  const parentFormInput = easySizeButton.closest('.product-form__input');
  if (!parentFormInput) return;

  const legend = parentFormInput.querySelector('legend');
  if (!legend) return;

  // Hide the EasySize button in place — don't move it into the legend
  easySizeButton.style.cssText = 'display:none !important;';

  // Inject our plain link into the option-name span
  const optionNameSpan = legend.querySelector('.product-form__option-name') || legend;

  const separator = document.createTextNode('\u00a0|\u00a0');
  const link = document.createElement('a');
  link.href = '#';
  link.textContent = 'Find Your Size';
  link.className = 'ntg-size-guide-link';
  link.addEventListener('click', function(e) {
    e.preventDefault();
    easySizeButton.style.cssText = '';
    const trigger = easySizeButton.querySelector('button, a, [role="button"]') || easySizeButton;
    trigger.click();
    easySizeButton.style.cssText = 'display:none !important;';
  });

  optionNameSpan.appendChild(separator);
  optionNameSpan.appendChild(link);

  clearInterval(buttonCheckInterval);
}

const buttonCheckInterval = setInterval(injectSizeGuideLink, 10);
setTimeout(() => clearInterval(buttonCheckInterval), 10000);
  } catch(e) { console.error(e); }
})();

})();
